import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel } from '@material-ui/core';

import FormTextField from '../../components/DynamicForm/FormTextField';
import { generateUUID } from '../../utils/commonUtil';

import './AddOrUpdateField.scss';
import { FieldData } from './AddOrUpdateField';

interface AddNewFieldProps {
    data?: FieldData;
    isMultiline?: boolean;
    onChange: (_field: any) => void;
};

const AddInputField = ({ data, isMultiline = false, onChange }: AddNewFieldProps) => {
    const { t } = useTranslation();

    const [inputFieldName, setInputFieldName] = useState<string>('');
    const [isRequired, setIsRequired] = useState<boolean>(false);

    const toggleIsRequired = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsRequired(event.target.checked);
    };

    const fieldData = useMemo(() => {
        return {
            name: inputFieldName,
            key: generateUUID().replace(/-/g, ''),
            isRequired,
        }
    }, [inputFieldName, isRequired]);

    useEffect(() => {
        if (data) {
            setInputFieldName(data.title);
            setIsRequired(data.isRequired);
            onChange(fieldData);
        }
    }, [data, isMultiline]);

    useEffect(() => {
        if (inputFieldName) {
            onChange(fieldData);
        } else {
            onChange(null);
        }
    }, [isRequired, inputFieldName])

    return (
        <div className="addFieldFormContainer">
            <div>
                { isMultiline ? t('CREATE_OR_UPDATE_FORM_MULTI_LINE_TEXT') : t('CREATE_OR_UPDATE_FORM_SINGLE_LINE_TEXT') }
            </div>
            <FormTextField
                id="new-input-field"
                title={t('CREATE_OR_UPDATE_FORM_FIELD_LABEL')}
                placeholder={true}
                value={inputFieldName}
                isMultiline={isMultiline}
                onChange={(_, val) => setInputFieldName(val)}
            />
            <div>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isRequired}
                            onChange={toggleIsRequired}
                            color="primary"
                            style={{ transform: 'scale(1)' }}
                        />
                    }
                    label={t('CREATE_OR_UPDATE_FORM_FIELD_IS_REQUIRED')}
                />
            </div>
        </div>
    );
};

export default AddInputField;
